module.exports = __webpack_public_path__ + "static/media/exportToCancerGenomicsCloudIcon.47c3b602.svg";